import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the ApplicationProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ApplicationProvider {

  constructor(public http: Http) {
    console.log('Hello ApplicationProvider Provider');
  }



/**
 * Liefert den Index des lokalen Names aus dem event.path
 * 
 * @param {any} $event Der Event der durchsucht wird
 * @param {string} localname Der lokale Name, der gesucht werden soll
 * @returns {number} Der Index des ersten Vorkommens des lokalen Namens oder NaN, wenn der lokale Name nicht gefunden wurde
 * @memberof ApplicationProvider
 */
public getIndexbyLocalName($event, localname:string): number{
  for (var i = 0; i < $event.path.length; i++)
{
    
  console.log('$event.path[i]: ' + $event.path[i].localName);
  //contentwidth = contentwidth + el.children[i].clientWidth;
    if($event.path[i].localName == localname){
return i;
    }
    
}
  //NaN, wenn kein entsprechender lokaler Name gefunden wurde.
  return NaN;
}


}




// WEBPACK FOOTER //
// ./src/providers/application/application.ts